import { render, staticRenderFns } from "./InstructionalVids.vue?vue&type=template&id=21fa681e&scoped=true&"
import script from "./InstructionalVids.vue?vue&type=script&lang=js&"
export * from "./InstructionalVids.vue?vue&type=script&lang=js&"
import style0 from "./InstructionalVids.vue?vue&type=style&index=0&id=21fa681e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21fa681e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VDivider,VImg,VRow})
